module.exports = __webpack_public_path__ + "img/game-background-blur.04db68de.svg";